import { ForeignAddress } from '@shared/types'
import { COMMON_PLACEHOLDER } from '@ui-components/global/constants'
import { JSX } from 'react'

interface AddressProps {
  address: ForeignAddress
}

export const ForeignAddressFields = ({ address }: AddressProps): JSX.Element => {
  return (
    <>
      <span>
        {address.street}
        <br />
      </span>
      <span>
        {address.foreignAddressLine1 ?? COMMON_PLACEHOLDER}
        <br />
      </span>
      <span>
        {address.foreignAddressLine2 ?? COMMON_PLACEHOLDER}
        <br />
      </span>
      <span>
        {address.countryName ?? COMMON_PLACEHOLDER}
        <br />
      </span>
    </>
  )
}
